export const isFirefox = () => /Firefox\/([0-9]+)\./i.test(navigator.userAgent);
